import { z } from "zod";

/**
 * BOŞ METİN = YOK.
 *
 * ⚠ Form alanları boş bırakıldığında `""` gönderiyor; ham hâlde `email` doğrulaması buna
 * "geçerli bir e-posta girin", `nationalId` regex'i "11 haneli olmalıdır" der ve kullanıcı
 * DOLDURMADIĞI bir alan yüzünden kaydedemez. Dönüşüm şemada, arayüzde değil: iki taraf da
 * aynı kuralı okusun (kriter 5) ve doğrudan API çağıran istemci de aynı davranışı görsün.
 *
 * ### Neden ortak dosyada
 *
 * Kural önce `clientContact` şemasında doğdu, sonra müvekkil oluşturmada (CLOS-627) aynı
 * tuzak tekrar çıktı. Refleks 10: aynı düzeltme ikinci kez isteniyorsa kural bir katmana
 * gömülür. İki yerde iki kopya, birinin gün gelip diğerinden ayrışması demekti.
 *
 * ⚠ Yalnız `nullish()` alanlarda kullanılır. Zorunlu bir alanı sarmak, "boş bıraktım"ı
 * sessizce "göndermedim"e çevirir ve zorunluluk hatasını gizlerdi.
 */
export function bosuYokSay<T extends z.ZodType>(sema: T) {
  return z.preprocess((v) => (typeof v === "string" && v.trim() === "" ? null : v), sema);
}
